module.exports = __webpack_public_path__ + "img/1519599786.b48dd1ba.jpg";